import { Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Account } from '../../../models/AccountModel';
import { PlatformApiService } from '../../../services/platform-api.service';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-score-histogram-component',
  templateUrl: './score-histogram-component.component.html',
  styleUrls: ['./score-histogram-component.component.scss']
})
export class ScoreHistogramComponentComponent implements OnInit, AfterViewInit {

  @ViewChild('myCanvas', { static: true }) canvas: ElementRef;
  @ViewChild('chartDiv', { static: true }) chartDiv: ElementRef;
  @Input() parentAccount: Account
  histogram = [];

  constructor(private cd: ChangeDetectorRef, private _platformApi: PlatformApiService) { }

  public barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: '<- High   RISK   Low ->'
        },
        gridLines: {
          display: false,
          drawTicks: false
        },
        ticks: {
          min: 0,
          max: 100,
          display: false
        }
      }],
      yAxes: [{
        scaleLabel: {
          display: true,
          labelString: '# of Companies'
        },
        gridLines: {
          display: false,
          drawTicks: false
        },
        ticks: {
          display: false
        }
      }]
    },
  };
  public barChartLabels: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = false;
  public barChartColors: Array<any>;

  public barChartData: any[] = [
    { data: [], label: 'Companies' }
  ];

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  ngAfterViewInit() {
    this.calculateGradient();
    this.cd.detectChanges();
  }

  calculateGradient() {
    const gradient = this.canvas.nativeElement.getContext('2d').createLinearGradient(0, 0, this.canvas.nativeElement.clientWidth, 0);

    gradient.addColorStop(1, 'rgba(91, 186, 71, 1)');
    gradient.addColorStop(.7, 'rgba(155, 178, 0, 1)');
    gradient.addColorStop(.5, 'rgba(216, 164, 10, 1)');
    gradient.addColorStop(.3, 'rgba(212, 103, 0, 1)');
    gradient.addColorStop(0, 'rgba(229, 58, 53, 1)');

    this.barChartColors = [{
      backgroundColor: gradient,
      hoverBackgroundColor: gradient,
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
    }];
  }

  ngOnInit() {
    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.pipe(debounceTime(500)).subscribe( evt => {
      this.calculateGradient();
      this.cd.detectChanges();
      })

    const bucketSize = 5;
    for (let i = 0; i < 100 / bucketSize; i++) {
      this.barChartLabels.push(`${(i + 1) * bucketSize}`);
    }

    const self = this;
    this._platformApi.getScoreHistogramChartData(this.parentAccount.id, null, null, bucketSize).subscribe(histogram => {
      const data = [];
      for (let i = 0; i < 100 / bucketSize; i++) {
        data.push(0);
      }
      if (Array.isArray(histogram)) {
        histogram.forEach(row => {
          const inx = (row.score / bucketSize) - 1;
          data[inx] = row.total;
        });
      }

      this.barChartData = [{
        data, label: 'Companies'
      }];
    });
  }

}
